export default {
  name: 'st-select',
  inheritAttrs: false
}
